import script from "./FeedbackCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackCard.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackCard.vue?vue&type=style&index=0&id=535f938a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535f938a"]])

export default __exports__